import React from "react";

const Header = () => {
  return (
    <header style={styles.header}>
      <a href="/" style={styles.logoLink}>
        <img src="/images/dl-logo.png" alt="Digital Ladyland Logo" style={styles.logo} />
      </a>
    </header>
  );
};

const styles = {
  header: {
    backgroundColor: "transparent",  // fully transparent
    color: "white",
    padding: "1.5rem 2rem",
    position: "relative",             // not sticky, scrolls with content
    zIndex: 10,
    textAlign: "center",
    borderBottom: "none",            // no line
  },
  logoLink: {
    textDecoration: "none",
  },
  logo: {
    height: "150px", // adjust as needed
  },
};

export default Header;
